import React, { Component } from 'react';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { signInUser } from '../../actions/index';
import blue from '../../assets/images/background/blue.svg';
import yellow from '../../assets/images/background/yellow.svg';
import { FORGET_PASSWORD } from '../../constants/config';
import { destructServerErrors } from '../../helpers/error';
import { showMessage } from '../../helpers/table';
import { postData } from '../../services/base_services';
import Form from './Form';
import PropTypes from 'prop-types';
class ForgetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      errors: {}
    };
  }

  submitForm = (data) => {
    this.setState({ isLoading: true });
    const { history } = this.props;
    postData(FORGET_PASSWORD, data)
      .then((res) => {
        
        this.setState({
          errors: []
        });
        showMessage(res.data.message, true);
      })
      .catch((err) => {
        const errs = destructServerErrors(err);
        this.setState({
          errors: errs
        });
      });
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 500);
  };

  render() {
    const { errors, isLoading } = this.state;
    return (
      <>
        <section className="login">
          <div
            className="login-background"
            style={{ backgroundImage: `url(${yellow})` }}
          >
            <img className="login-background-bot" src={blue} alt="" />
          </div>

          <Form
            submitForm={this.submitForm}
            errors={errors}
            isLoading={isLoading}
          />
        </section>
        <NotificationContainer />
      </>
    );
  }
}

ForgetPassword.propTypes = {
  history: PropTypes.func.isRequired,
};

const MapDispatchToProp = (dispatch) => {
  return {
    signInUser: (data) => dispatch(signInUser(data))
  };
};

export default connect(null, MapDispatchToProp)(withRouter(ForgetPassword));
